import { styled } from '@abyss/web/tools/styled';

import { desktopOnly, mobileOnly, notMobile } from '../../ConstantsStyles';

export const ModalOverlayStyles = {
  'abyss-modal-overlay': {
    background: 'rgba(0, 0, 0, 0.5)',
  },
  'abyss-modal-header-container': {
    marginTop: 0,
    padding: 0,
  },
  'abyss-modal-close-button': {
    marginTop: '32px',
    marginRight: '44px',
    [`@media ${mobileOnly}`]: {
      marginTop: '20px',
      marginRight: '20px',
    },
  },
  'abyss-modal-content-title': {
    padding: '0px',
    fontWeight: '700',
    fontSize: '32px',
    lineHeight: '40px',
    [`@media ${mobileOnly}`]: {
      fontSize: '28px',
      lineHeight: '36px',
    },
  },
  'abyss-modal-content-container': {
    padding: '40px $xl', // top/bottom 40px, left/right $xl (48px)
    borderRadius: '16px',
    width: '583px',
    maxWidth: '100%',
    // height: '1052px',
    [`@media ${mobileOnly}`]: {
      padding: '$lg', // all sides 24px — overrides cleanly now
    },
    [`@media ${notMobile}`]: {
      width: '928px',
    },
    [`@media ${desktopOnly}`]: {
      width: '1152px',
    },
    '.abyss-modal-footer': {
      padding: 0,
      borderRadius: '0px 0px 16px 16px',
    },
  },
  'abyss-modal-close-icon': {
    color: '$primary1',
  },
};

export const descriptionTextCss = {
  display: 'block',
  paddingTop: '$sm',
  paddingBottom: '$lg',
  color: '#42474D',
  width: '538px',
  maxWidth: '100%',
  [`@media ${mobileOnly}`]: {
    width: '100%',
  },
  // fontFamily: 'AbyssEnterpriseSansVF, Arial Bold, sans-serif !important',
};

export const Divider = styled('div', {
  height: '40px',
});

export const StyledModalFooter = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  paddingRight: '$xl',
  height: '66px',
  borderBottomLeftRadius: '16px',
  borderBottomRightRadius: '16px',
  backgroundColor: '$gray2', // grey
  // Break out of the modal content padding so the footer is full-bleed.
  // Content container padding is 48px sides / 40px bottom (24px on mobile).
  marginLeft: '-48px',
  marginRight: '-48px',
  marginBottom: '-40px',
  [`@media ${mobileOnly}`]: {
    marginLeft: '-24px',
    marginRight: '-24px',
    marginBottom: '-24px',
  },
});
